import React, { Component, Fragment } from 'react'
import AutoInput from '../containers/AutoInput'
import withValues from '../hocs/withValues'
import { getValue } from '../utils/models'

class Schedule extends Component {

  render() {
    return (
      <Fragment>
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={'dispatch'}
          id={this.props.id}
          autoSave
          attribute={'customerArrivalTime'}
          value={getValue(this.props.values, 'customerArrivalTime')}
          mode={'time'}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={'dispatch'}
          id={this.props.id}
          autoSave
          attribute={'customerDepartureTime'}
          value={getValue(this.props.values, 'customerDepartureTime')}
          mode={'time'}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={'dispatch'}
          id={this.props.id}
          autoSave
          attribute={'deliveryTime'}
          value={getValue(this.props.values, 'deliveryTime')}
          mode={'time'}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={'dispatch'}
          id={this.props.id}
          autoSave
          attribute={'shipperTime'}
          value={getValue(this.props.values, 'shipperTime')}
          mode={'time'}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={'dispatch'}
          id={this.props.id}
          autoSave
          attribute={'pedimentTime'}
          value={getValue(this.props.values, 'pedimentTime')}
          mode={'time'}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={'dispatch'}
          id={this.props.id}
          autoSave
          attribute={'customQueue'}
          value={getValue(this.props.values, 'customQueue')}
          mode={'time'}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={'dispatch'}
          id={this.props.id}
          autoSave
          attribute={'customHouseMx'}
          value={getValue(this.props.values, 'customHouseMx')}
          mode={'time'}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={'dispatch'}
          id={this.props.id}
          autoSave
          attribute={'statusMx'}
          value={getValue(this.props.values, 'statusMx')}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={'dispatch'}
          id={this.props.id}
          autoSave
          attribute={'customHouseUs'}
          value={getValue(this.props.values, 'customHouseUs')}
          mode={'time'}
        />
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={'dispatch'}
          id={this.props.id}
          autoSave
          attribute={'statusUs'}
          value={getValue(this.props.values, 'statusUs')}
        />
        <AutoInput
          form={this.props.form}
          disabled
          model={'dispatch'}
          id={this.props.id}
          autoSave
          attribute={'finishedAt'}
          value={getValue(this.props.values, 'finishedAt')}
          mode={'time'}
        />
      </Fragment>
    )
  }

}

export default withValues(Schedule)



// WEBPACK FOOTER //
// ./src/forms/Schedule.js